import {ViewController} from "data/types/structure";
import {injectable} from "inversify";
import {makeAutoObservable, runInAction} from "mobx";

export interface IWidgetLoaderController extends ViewController {
	get isReady(): boolean;
}

@injectable()
export class WidgetLoaderController implements IWidgetLoaderController {
	// Change to false in case if we require some data from the parent site
	private _isReady = true;
	private _widgetID = 0;

	constructor() {
		makeAutoObservable(this);
	}

	get isReady(): boolean {
		return this._isReady || window.location.hostname.includes(".loc");
	}

	dispose(): void {
		window.removeEventListener("message", this.listenDataEvent);
	}

	init() {
		try {
			window.addEventListener("message", this.listenDataEvent);
			window.addEventListener("resize", () => this.resizeEvent());
		} catch (_err) {
			// Show error message to a user
		}
	}

	private listenDataEvent = (event: MessageEvent<unknown>) => {
		if (typeof event.data !== "string") {
			return;
		}
		const data = this.parseString(event.data) as {type: string; widgetId: number};
		if (data.type === "scoreboard_widget_data") {
			runInAction(() => {
				this._isReady = true;
				this._widgetID = data.widgetId;
			});
		}
	};

	private resizeEvent() {
		const height = window.document.body.clientHeight;

		window.parent.postMessage(
			JSON.stringify({
				height,
				widgetId: this._widgetID,
			}),
			"*"
		);
	}

	private parseString(value: string) {
		try {
			return JSON.parse(value) as {type: string; widgetId: number};
		} catch (e) {
			return {};
		}
	}
}
